// extracted by mini-css-extract-plugin
export var header = "_bo-0";